import { Modal } from "antd";
import { t } from "i18next";
import React from "react";

const ModalViewDetailAddListDA = ({ isModalOpen, close, data }) => {
  return (
    <Modal
      title=""
      open={isModalOpen}
      onCancel={close}
      footer={null}
      width={1300}
    >
      <div className="flex flex-col">
        <h3 className="font-roboto text-[20px] font-bold mb-3">
          {t("Delivery Associated Detail")}
        </h3>
        <div className="flex flex-row justify-between">
          {/* Row 1 */}
          <div className=" w-[26.1rem] flex flex-col">
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]">
                {" "}
                {t("Delivery Associate ID")}{" "}
              </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.delivery_associate_id
                  ? data?.delivery_associate_id
                  : "-"}{" "}
              </p>
            </div>
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]"> {t("Last Name")} </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.last_name ? data?.last_name : "-"}{" "}
              </p>
            </div>
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]">
                {" "}
                {t("Vehicle Number")}{" "}
              </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.vehicle_no ? data?.vehicle_no : "-"}{" "}
              </p>
            </div>
          </div>

          {/* Row 2 */}
          <div className=" w-[26.1rem] flex flex-col">
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]"> {t("Driver ID")} </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.driver_id ? data?.driver_id : "-"}{" "}
              </p>
            </div>
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]"> {t("Vehicle ID")} </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.vehicle_id ? data?.vehicle_id : "-"}{" "}
              </p>
            </div>
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]">
                {" "}
                {t("Trip Status")}{" "}
              </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.trip_id ? data?.trip_id : "-"}{" "}
              </p>
            </div>
          </div>

          {/* Row 3 */}
          <div className=" w-[26.1rem] flex flex-col">
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]"> {t("First Name")} </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.first_name ? data?.first_name : "-"}{" "}
              </p>
            </div>
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]">
                {" "}
                {t("Vehicle Model")}{" "}
              </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.vehicle_type ? data?.vehicle_type : "-"}{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalViewDetailAddListDA;
